import { createSlice } from "@reduxjs/toolkit";
import { fetchFixedAssetLedger } from "./fixedAssetLedgerThunk";

const initialState = {
  list: [],
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
  opening_balance: 0,
  closing_balance: 0,
  loading: false,
};

const fixedAssetLedgerSlice = createSlice({
  name: "fixedAssetLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFixedAssetLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFixedAssetLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.ledger;
        state.opening_balance = action.payload.opening_balance;
        state.closing_balance = action.payload.closing_balance;
      })
      .addCase(fetchFixedAssetLedger.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = fixedAssetLedgerSlice.actions;
export default fixedAssetLedgerSlice.reducer;
